define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/def/Field",
	"csi/resolver",
	"csi/table/New",
	"csi/xml",
	"Apparel/MaterialForm"
], function(declare,lang,csi,Field,resolver,New,xml,MaterialForm) {

	var	_Form = declare(MaterialForm, {
		_resolveView: function() {
			var	fd = this.defView.m_formData;
			var pp = fd.getParent();
			var bp = resolver.resolveNode(pp.__Parent__, true);
			
			this.addDefaultValue(xml.ATTR_NAME, pp.$Name);
			
			if (bp.BPMSG != csi.EMPTY_URL) {
				this.addDefaultValue(xml.ATTR_PARENT, bp.BPMSG);
			}

			this.inherited(arguments);
		}
	});

	return declare(New, {
		/**
		 * Add special controller for form
		 */
		onCreatePopupDefView: function(defView) {
			defView.classController = _Form;
		},
		
		toWriter: function() {
			var	msg = this.getFormData().getFieldValue(xml.ATTR_PARENT, true);
			var	call = this.inherited(arguments);
			
			if (xml.isValidURL(msg)) {
            	this.m_writer.changeNode(msg).changeAttribute("SecurityGroupMaterials", xml.ATTR_REFLIST, [this.m_urlNode], true);
			}
 
            return call;
		}
	});
});